import React, { ReactElement } from 'react';
import { Button } from 'elmo-elements';

interface BottomPropType {
  continueHandler: any;
}

const Bottom = ({ continueHandler }: BottomPropType): ReactElement => (
  <div id="button-bar">
    <Button
      type="primary"
      onClick={() => {
        continueHandler();
      }}
    >
      Click to continue
    </Button>
  </div>
);

export default Bottom;
